export default __webpack_public_path__ + "static/media/croptop-small-back-toobig.4eab5e8f.jpg";